/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import Charla from '../../images/ATC/charla.png';
import Correo from '../../images/ATC/correo.png';
import Dinero from '../../images/ATC/dinero.png';
import Monitor from '../../images/ATC/monitor.png';
import UI from '../../images/ATC/ui.png';
import Wifi from '../../images/ATC/wifi.png';

import Telephone from '../../images/ATC/telephone.png';

import './styles.scss';

function ATC () {
  return (
    <div className="atc__container">
      <div className="atc__header__container">
        <p className="first__text">Chin,</p>
        <p className="second__text">¿algo no va bien?</p>
        <button>te ayudamos</button>
      </div>

      <div className="first__text">
        <p>Sabemos que la tecnología no siempre está de nuestro lado y los <span>inconvenientes suceden</span>. Por ello, <span>ponemos a tu disposición nuestros canales de Servicio al Cliente para ayudarte</span> a resolver aquellos fallos o dudas que tengas sobre:</p>
      </div>

      <div className="icons__container">
        <div className="balance__container">
          <img src={Dinero} atl="Consulta de saldo"></img>
          <p>Consulta de saldo</p>
        </div>
        <div className="telephone__container">
          <img src={UI} atl="Soporte Técnico Telefonía"></img>
          <p>Soporte Técnico Telefonía</p>
        </div>
        <div className="suggestion__container">
          <img src={Charla} atl="Quejas y sugerencia"></img>
          <p>Quejas y sugerencias</p>
        </div>
        <div className="internet__container">
          <img src={Wifi} atl="Soporte Técnico Internet"></img>
          <p>Soporte Técnico Internet</p>
        </div>
        <div className="tv__container">
          <img src={Monitor} atl="Soporte Técnico Televisión"></img>
          <p>Soporte Técnico Televisión</p>
        </div>
      </div>

      <div className="data__container">
        <div className="data__content">
          <img className="img__correo" src={Correo} atl="Correo electronico"></img>
          <p className="email">atencionclientes@xxxx.com.mx</p>
          <img className="img__telephone" src={Telephone} atl=""></img>
          <p className="telephone">673 690 0100</p>
        </div>
      </div>

      <div className="second__text">
        <p>Aumenta tu velocidad de internet o cambia tu <span>Doble plack por un Triple pack</span> a un precio inigualable.</p>
      </div>

      <button className="atc__button">te ayudamos</button>
    </div>
  );
}

export default ATC;
